import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext, useRef, useEffect, useState, useCallback, useMemo } from 'react';
import { useMergedState } from '../_utils/hooks';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { Icon, Tabs, Spin } from '../index';
import usePopper from '../_utils/usePopper';
import Option from './option';
import escapeRegExp from 'lodash/escapeRegExp';
import KeyCode from '../_utils/KeyCode';
import isObject from 'lodash/isObject';
var getCityId = function getCityId(data) {
  if (isObject(data)) {
    return data === null || data === void 0 ? void 0 : data.id;
  }
  return data;
};
var InternalSelect = function InternalSelect(props, ref) {
  var _context, _classNames3, _classNames6;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps,
    locale = _useContext.locale;
  var selectProps = getCompProps('CityPicker', userDefaultProps, props);
  var cityPickerLangMsg = locale.getCompLangMsg({
    componentName: 'CityPicker'
  });
  var type = selectProps.type,
    size = selectProps.size,
    value = selectProps.value,
    className = selectProps.className,
    defaultOpen = selectProps.defaultOpen,
    disabled = selectProps.disabled,
    borderType = selectProps.borderType,
    _selectProps$showArro = selectProps.showArrow,
    showArrow = _selectProps$showArro === void 0 ? true : _selectProps$showArro,
    allowClear = selectProps.allowClear,
    customPrefixcls = selectProps.prefixCls,
    onFocus = selectProps.onFocus,
    onBlur = selectProps.onBlur,
    onClear = selectProps.onClear,
    onVisibleChange = selectProps.onVisibleChange,
    onChange = selectProps.onChange,
    onSearch = selectProps.onSearch,
    defaultValue = selectProps.defaultValue,
    placeholder = selectProps.placeholder,
    _selectProps$dropdown = selectProps.dropdownStyle,
    dropdownStyle = _selectProps$dropdown === void 0 ? {} : _selectProps$dropdown,
    style = selectProps.style,
    clearIcon = selectProps.clearIcon,
    loading = selectProps.loading,
    showDescription = selectProps.showDescription,
    description = selectProps.description,
    optionHighlightProps = selectProps.optionHighlightProps,
    _selectProps$popperSt = selectProps.popperStyle,
    popperStyle = _selectProps$popperSt === void 0 ? {} : _selectProps$popperSt,
    _selectProps$commonLi = selectProps.commonList,
    commonList = _selectProps$commonLi === void 0 ? [] : _selectProps$commonLi,
    _selectProps$domestic = selectProps.domesticList,
    domesticList = _selectProps$domestic === void 0 ? [] : _selectProps$domestic,
    _selectProps$foreignL = selectProps.foreignList,
    foreignList = _selectProps$foreignL === void 0 ? [] : _selectProps$foreignL,
    itemRender = selectProps.itemRender,
    onTabPaneChange = selectProps.onTabPaneChange;
  var _useMergedState = useMergedState(undefined, {
      value: getCityId(value),
      defaultValue: getCityId(defaultValue)
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    initValue = _useMergedState2[0],
    setInitValue = _useMergedState2[1];
  var tabsData = [{
    id: 'domestic',
    name: cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.tabsDomestic
  }, {
    id: 'foreign',
    name: cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.tabsInternation
  }];
  var innerRef = useRef();
  var selectRef = ref || innerRef;
  var searchRef = useRef(null); // 搜索框ref
  var selectionRef = useRef(null);
  var clearRef = useRef(null);
  var optionsListRef = useRef(null);
  var _useState = useState(typeof props.visible === 'undefined' ? !!defaultOpen : !!props.visible),
    _useState2 = _slicedToArray(_useState, 2),
    optionShow = _useState2[0],
    setOptionShow = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    focusd = _useState6[0],
    setFocusd = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    afterChangeFocus = _useState8[0],
    setAfterChangeFocus = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    seletedCity = _useState10[0],
    setSeletedCity = _useState10[1];
  var _useState11 = useState('domestic'),
    _useState12 = _slicedToArray(_useState11, 2),
    tabsValue = _useState12[0],
    setTabsValue = _useState12[1];
  var isDomestic = function isDomestic(type) {
    return type === 'domestic';
  };
  var selectPrefixCls = getPrefixCls(prefixCls, 'city-picker', customPrefixcls);
  var cityPickerCls = classNames(selectPrefixCls, className, _defineProperty({}, "".concat(selectPrefixCls, "-visible"), optionShow));
  var selectionCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-selector"), true));
  // 公共样式
  var commCls = classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(selectPrefixCls, "-bordered"), borderType === 'bordered'), _defineProperty(_classNames3, "".concat(selectPrefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classNames3, "".concat(selectPrefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames3, _concatInstanceProperty(_context = "".concat(selectPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames3, "".concat(selectPrefixCls, "-wrapper"), true), _defineProperty(_classNames3, "".concat(selectPrefixCls, "-show-search"), focusd), _classNames3));
  useEffect(function () {
    var _context2;
    if (typeof value === 'undefined') return;
    if (isObject(value)) {
      setSeletedCity(value);
      return;
    }
    var cityList = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(commonList), _toConsumableArray(domesticList), _toConsumableArray(foreignList));
    var city = _findInstanceProperty(cityList).call(cityList, function (city) {
      return city.id === value;
    });
    setSeletedCity(city);
  }, [commonList, domesticList, foreignList, value]);
  useEffect(function () {
    if (typeof props.visible !== 'undefined') {
      setOptionShow(props.visible);
    }
  }, [props.visible]);
  var handleFocus = useCallback(function (e) {
    e.stopPropagation();
    setFocusd(true);
    onFocus && onFocus(e);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    e.stopPropagation();
    setFocusd(false);
    setAfterChangeFocus(false);
    onBlur && onBlur(e);
  }, [onBlur]);
  useEffect(function () {
    selectionRef.current.addEventListener('mouseup', function (e) {
      var _a;
      var isCloseBtn = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className.indexOf('kd-tag-close-icon')) > -1;
      if (isCloseBtn) {
        e.stopPropagation();
      }
    });
  }, []);
  // 输入框变化搜索内容
  var handleSearchChange = useCallback(function (event) {
    var val = event.currentTarget.value;
    setOptionShow(true);
    setSearchValue(val);
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(val);
  }, [onSearch]);
  // 清除搜索内容
  var handleClear = useCallback(function () {
    if (searchRef.current) {
      searchRef.current.value = '';
      setSearchValue('');
    }
  }, [searchRef]);
  // 清空选择器内容
  var handleReset = function handleReset(e) {
    e.stopPropagation();
    onClear && onClear('');
    setInitValue('');
    setSeletedCity(null);
    setSearchValue('');
    onChange && onChange(undefined, '');
  };
  // 渲染后缀图标
  var renderSuffix = function renderSuffix() {
    var _classNames4;
    if (disabled) return null;
    var suffixIcon = selectProps.suffixIcon;
    var arrowIconCls = classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(selectPrefixCls, "-icon-arrow"), true), _defineProperty(_classNames4, "".concat(selectPrefixCls, "-icon-arrow-up"), optionShow), _defineProperty(_classNames4, "".concat(selectPrefixCls, "-icon-arrow-down"), !optionShow), _defineProperty(_classNames4, "".concat(selectPrefixCls, "-icon-arrow-focus"), optionShow), _classNames4));
    var iconShow = allowClear && !disabled && (initValue !== null && initValue !== void 0 ? initValue : '') !== '';
    return /*#__PURE__*/React.createElement(React.Fragment, null, iconShow && /*#__PURE__*/React.createElement("span", {
      onClick: handleReset,
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      className: "".concat(selectPrefixCls, "-icon-clear"),
      ref: clearRef
    }, clearIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    })), showArrow && /*#__PURE__*/React.createElement("span", {
      className: arrowIconCls
    }, suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down"
    })));
  };
  // 下拉列表为空时显示的内容
  var renderNotContent = function renderNotContent(msg) {
    var notFoundContent = selectProps.notFoundContent;
    var emptyContent = notFoundContent || msg;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(selectPrefixCls, "-dropdown-empty")
    }, emptyContent);
  };
  var getHighlightText = function getHighlightText(text, inputValue) {
    if (!inputValue || !text) return text;
    var regex = new RegExp(Array.isArray(inputValue) ? _mapInstanceProperty(inputValue).call(inputValue, function (item) {
      return "(".concat(escapeRegExp(item), ")");
    }).join('|') : "(".concat(escapeRegExp(inputValue), ")"), 'i');
    var strArr = text === null || text === void 0 ? void 0 : text.split(regex);
    return /*#__PURE__*/React.createElement(React.Fragment, null, strArr === null || strArr === void 0 ? void 0 : _mapInstanceProperty(strArr).call(strArr, function (item, index) {
      return (regex === null || regex === void 0 ? void 0 : regex.test(item)) ? /*#__PURE__*/React.createElement("span", {
        key: index,
        className: "".concat(selectPrefixCls, "-highlight")
      }, item) : /*#__PURE__*/React.createElement("span", {
        key: index
      }, item);
    }));
  };
  var handleOption = function handleOption(city) {
    var _a;
    handleVisibleChange(false);
    city.type = tabsValue === 'domestic' ? 'domestic' : 'foreign';
    (city === null || city === void 0 ? void 0 : city.id) !== initValue && (onChange === null || onChange === void 0 ? void 0 : onChange(city === null || city === void 0 ? void 0 : city.id, city));
    (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    setAfterChangeFocus(true);
    if (typeof value === 'undefined') {
      setSeletedCity(city);
      setInitValue(city === null || city === void 0 ? void 0 : city.id);
    }
  };
  var renderNodeList = function renderNodeList(data, notContent) {
    var isCommon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!data.length) {
      return renderNotContent(notContent);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(selectPrefixCls, "-list"),
      ref: optionsListRef,
      onMouseDown: function onMouseDown(e) {
        return e === null || e === void 0 ? void 0 : e.preventDefault();
      }
    }, _mapInstanceProperty(data).call(data, function (item, index) {
      return /*#__PURE__*/React.createElement(Option, {
        key: item.id,
        value: initValue,
        city: item,
        className: searchValue ? "".concat(selectPrefixCls, "-list-item-match") : undefined,
        renderCityInfo: function renderCityInfo(data, flag) {
          return _renderCityInfo(data, isCommon, flag);
        },
        onChangeSelect: handleOption,
        itemRender: itemRender,
        activeIndex: activeIndex,
        index: index,
        onChangeActiveIndex: function onChangeActiveIndex(i) {
          setActiveIndex(i);
        }
      }, searchValue ? getHighlightText(item === null || item === void 0 ? void 0 : item.name, (item === null || item === void 0 ? void 0 : item[optionHighlightProps]) || searchValue) : item === null || item === void 0 ? void 0 : item.name);
    }));
  };
  var renderLoading = function renderLoading() {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(selectPrefixCls, "-dropdown-loading")
    }, /*#__PURE__*/React.createElement(Spin, {
      type: "container"
    }));
  };
  var toggleTabPane = function toggleTabPane(type) {
    setTabsValue(type);
    onTabPaneChange === null || onTabPaneChange === void 0 ? void 0 : onTabPaneChange(type);
  };
  // 渲染下拉列表框
  var renderContent = function renderContent() {
    return loading ? renderLoading() : /*#__PURE__*/React.createElement(React.Fragment, null, searchValue ? /*#__PURE__*/React.createElement(React.Fragment, null, isDomestic(type) && /*#__PURE__*/React.createElement(Tabs, {
      noContainer: true,
      onChange: toggleTabPane,
      activeKey: tabsValue
    }, _mapInstanceProperty(tabsData).call(tabsData, function (item) {
      return /*#__PURE__*/React.createElement(Tabs.TabPane, {
        key: item.id,
        tab: item.name
      }, item);
    })), tabsValue === 'domestic' ? renderNodeList(domesticList, cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.emptyText) : renderNodeList(foreignList, cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.emptyText)) : /*#__PURE__*/React.createElement(React.Fragment, null, !!commonList.length && /*#__PURE__*/React.createElement("div", {
      className: "".concat(selectPrefixCls, "-dropdown-common")
    }, cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.common), renderNodeList(commonList, cityPickerLangMsg === null || cityPickerLangMsg === void 0 ? void 0 : cityPickerLangMsg.commonEmptyText, true)));
  };
  var _renderCityInfo = useCallback(function (data) {
    var isCommon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var symbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ', ';
    if (!data) return null;
    if (isDomestic(type)) {
      var _context5;
      if (isCommon) {
        var _context3;
        var _curVal = (data === null || data === void 0 ? void 0 : data.province) ? data === null || data === void 0 ? void 0 : data.province : data === null || data === void 0 ? void 0 : data.country;
        return _concatInstanceProperty(_context3 = "".concat(flag && _curVal ? symbol : '')).call(_context3, _curVal);
      }
      if (data === null || data === void 0 ? void 0 : data.type) {
        var _context4;
        var _curVal2 = data.type === 'domestic' ? (data === null || data === void 0 ? void 0 : data.province) || (data === null || data === void 0 ? void 0 : data.country) : data === null || data === void 0 ? void 0 : data.country;
        return _concatInstanceProperty(_context4 = "".concat(flag && _curVal2 ? symbol : '')).call(_context4, _curVal2);
      }
      var curVal = tabsValue === 'domestic' ? (data === null || data === void 0 ? void 0 : data.province) || (data === null || data === void 0 ? void 0 : data.country) : data === null || data === void 0 ? void 0 : data.country;
      return _concatInstanceProperty(_context5 = "".concat(flag && curVal ? symbol : '')).call(_context5, curVal);
    } else {
      var _context6, _context7, _context8;
      return _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "".concat(flag && ((data === null || data === void 0 ? void 0 : data.province) || (data === null || data === void 0 ? void 0 : data.country)) ? symbol : '')).call(_context8, data === null || data === void 0 ? void 0 : data.province)).call(_context7, (data === null || data === void 0 ? void 0 : data.country) && (data === null || data === void 0 ? void 0 : data.province) ? symbol : '')).call(_context6, data === null || data === void 0 ? void 0 : data.country);
    }
  }, [type, tabsValue]);
  var renderSingle = function renderSingle() {
    var _classNames5;
    var hiddenStyle = !!searchValue || (initValue !== null && initValue !== void 0 ? initValue : '') !== '' ? {
      visibility: 'hidden'
    } : undefined;
    var itemCls = classNames((_classNames5 = {}, _defineProperty(_classNames5, "".concat(selectPrefixCls, "-content-item"), true), _defineProperty(_classNames5, "".concat(selectPrefixCls, "-content-item-seleted"), afterChangeFocus), _classNames5));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: singleCls,
      ref: selectionRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(selectPrefixCls, "-content")
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-content-search")
    }, /*#__PURE__*/React.createElement("input", {
      ref: searchRef,
      value: searchValue,
      className: "".concat(selectPrefixCls, "-content-search-input"),
      onChange: handleSearchChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      readOnly: !!disabled
    }), !searchValue && /*#__PURE__*/React.createElement("span", {
      className: itemCls,
      title: seletedCity === null || seletedCity === void 0 ? void 0 : seletedCity.name
    }, seletedCity === null || seletedCity === void 0 ? void 0 : seletedCity.name)), !searchValue && /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-content-info")
    }, _renderCityInfo(seletedCity))), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-placeholder"),
      style: hiddenStyle
    }, !disabled ? placeholder : null), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-suffix")
    }, renderSuffix())));
  };
  var singleCls = classNames(commCls, (_classNames6 = {}, _defineProperty(_classNames6, "".concat(selectPrefixCls, "-disabled"), disabled), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-focused"), !disabled && focusd || optionShow), _classNames6));
  useEffect(function () {
    if (optionShow && !disabled) {
      var onDropdownVisibleChange = selectProps.onDropdownVisibleChange;
      onDropdownVisibleChange && onDropdownVisibleChange(true);
    }
  }, [optionShow]);
  useEffect(function () {
    var _a;
    var fn = function fn(e) {
      e.stopPropagation();
    };
    (_a = clearRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseup', fn);
    return function () {
      var _a;
      (_a = clearRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseup', fn);
    };
  }, [initValue]);
  // keyboard
  var curkeyboardList = useMemo(function () {
    if (!searchValue) {
      return commonList;
    } else if (tabsValue === 'domestic') {
      return domesticList;
    } else {
      return foreignList;
    }
  }, [commonList, domesticList, foreignList, searchValue, tabsValue]);
  var getActiveIndex = function getActiveIndex(index) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var len = curkeyboardList.length;
    for (var i = 0; i < len; i += 1) {
      var current = (index + i * offset + len) % len;
      return current;
    }
    return -1;
  };
  var _useState13 = useState(-1),
    _useState14 = _slicedToArray(_useState13, 2),
    activeIndex = _useState14[0],
    setActiveIndex = _useState14[1];
  var initActiveIndex = function initActiveIndex() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    setActiveIndex(index === undefined ? getActiveIndex(0) : index);
  };
  useEffect(function () {
    initActiveIndex(searchValue ? undefined : -1);
  }, [searchValue, tabsValue, curkeyboardList]);
  var onInternalKeyDown = function onInternalKeyDown(e) {
    var _a, _b, _c;
    var which = e.which;
    // open
    if (which === KeyCode.ENTER || which === KeyCode.UP || which === KeyCode.DOWN) {
      e.preventDefault();
      setOptionShow(true);
    }
    // up、down、enter、esc
    if (optionShow) {
      var offset = 0;
      switch (which) {
        case KeyCode.UP:
          offset = -1;
          break;
        case KeyCode.DOWN:
          offset = 1;
          break;
        case KeyCode.ENTER:
          {
            var item = curkeyboardList[activeIndex];
            if (!item) return;
            handleOption(item);
            handleVisibleChange(false);
            break;
          }
        case KeyCode.ESC:
          handleVisibleChange(false);
          break;
        default:
          break;
      }
      if (offset !== 0) {
        var nextActiveIndex = getActiveIndex(activeIndex + offset, offset);
        var curDom = (_b = (_a = optionsListRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b[nextActiveIndex];
        if (curDom) {
          (_c = optionsListRef.current) === null || _c === void 0 ? void 0 : _c.children[nextActiveIndex].scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
          });
        }
        setActiveIndex(nextActiveIndex);
        e.preventDefault();
      }
    }
  };
  var renderCityPicker = function renderCityPicker() {
    return /*#__PURE__*/React.createElement("div", {
      className: cityPickerCls,
      ref: selectRef,
      style: style
    }, showDescription && /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-description")
    }, description), /*#__PURE__*/React.createElement("span", {
      className: selectionCls,
      tabIndex: disabled ? -1 : 0,
      onFocus: function onFocus() {
        var _a;
        return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      onBlur: function onBlur() {
        var _a;
        return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },
      onKeyDown: onInternalKeyDown
    }, renderSingle()));
  };
  var catchStyle = function catchStyle() {
    var _a;
    if (selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) {
      var _ref = (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
        width = _ref.width;
      return _extends(_extends(_extends({
        minWidth: width,
        maxWidth: 600
      }, dropdownStyle), {
        width: (dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.width) || 'auto',
        zIndex: 1050
      }), popperStyle);
    }
  };
  var handleVisibleChange = function handleVisibleChange(visible) {
    if (!visible) {
      initActiveIndex(-1);
    }
    if (visible !== optionShow) {
      props.visible === undefined && setOptionShow(visible);
      onVisibleChange && onVisibleChange(visible);
    }
  };
  var popperProps = _extends(_extends({}, selectProps), {
    prefixCls: "".concat(selectPrefixCls, "-dropdown"),
    placement: 'bottomLeft',
    popperStyle: catchStyle(),
    defaultVisible: optionShow,
    visible: optionShow,
    onVisibleChange: handleVisibleChange,
    clickToClose: !searchValue,
    onTransitionEnd: function onTransitionEnd() {
      if (optionShow === false) {
        handleClear();
      }
    }
  });
  return usePopper(renderCityPicker(), renderContent(), popperProps);
};
var Select = /*#__PURE__*/React.forwardRef(InternalSelect);
Select.displayName = 'CityPicker';
export default Select;